export default {"src":"/_next/static/media/carPageBackground.4ad56dde.svg","height":490,"width":1467,"blurWidth":0,"blurHeight":0};